import React from 'react';
import { createRoot } from 'react-dom/client';

import { RootModule } from '@/modules/Root';
import { Sentry } from '@/services/Sentry';

import 'react-app-polyfill/stable';

Sentry.init();

grecaptcha.ready(function () {
  const container = document.getElementById('root') as HTMLElement;
  const root = createRoot(container);

  root.render(<RootModule />);
});
